import * as yup from 'yup';
import dayjs from 'dayjs';
import { providerNPISchema, requiredErrorMessage } from '@common/schema';
import { LicensesTypes, LicensesUnits } from '@common/types';

export const licensesSchema = yup.object().shape({
  npi: providerNPISchema.required(requiredErrorMessage),
  guide_certified: yup.boolean().required(requiredErrorMessage),
  guide_certification_date: yup
    .mixed<dayjs.Dayjs>()
    .required(requiredErrorMessage),
  licenses: yup
    .array()
    .of(
      yup.object().shape({
        value: yup.string(),
        type: yup.mixed<LicensesTypes>().oneOf(Object.values(LicensesUnits)),
      }),
    )
    .required(),
});
